import request from "@/utils/request";

export const pointCompensation = {
  list: (params) =>
    request({
      url: "/api/backend/integral/compensate/list",
      method: "GET",
      params,
    }),
  create: (data) =>
    request({
      url: "/api/backend/integral/compensate/add",
      method: "POST",
      data: { ...data, compensate_type: 0 },
    }),
  revoke: (id) =>
    request({
      url: "/api/backend/integral/compensate/add",
      method: "POST",
      data: { compensate_type: 1, id },
    }),
  transactionDetail: (params) =>
    request({
      url: "/api/backend/integral/total/log",
      method: "GET",
      params,
    }),
};
